import React from 'react';
import { Card } from './ui/card';
import { GraduationCap, Award } from 'lucide-react';

const Education = () => {
  const education = [
    {
      degree: 'B.E. Computer Science',
      institution: 'Velammal Institute of Technology',
      period: '2023 - 2027',
      grade: 'CGPA: 9.44 / 10',
      icon: GraduationCap,
      color: 'teal',
    },
    {
      degree: 'Intermediate (MPC)',
      institution: 'Narayana Junior College',
      period: '2021 - 2023',
      grade: '95%',
      icon: Award,
      color: 'blue',
    },
    {
      degree: 'SSC',
      institution: 'Sudhaha Little Citizens School',
      period: '2021',
      grade: '100%',
      icon: Award,
      color: 'green',
    },
  ];

  return (
    <section id="education" className="py-20 px-6 bg-slate-100/50 dark:bg-slate-900/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            My <span className="text-teal-500">Education</span>
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto rounded-full"></div>
        </div>

        <div className="space-y-8">
          {education.map((edu, index) => {
            const Icon = edu.icon;
            return (
              <Card
                key={index}
                className="p-8 bg-white/70 dark:bg-slate-800/70 backdrop-blur-sm border-slate-200 dark:border-slate-700 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] animate-in fade-in slide-in-from-bottom"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
                  <div
                    className={`p-4 rounded-full bg-${edu.color}-500/10 text-${edu.color}-500`}
                  >
                    <Icon className="h-8 w-8" />
                  </div>

                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
                      {edu.degree}
                    </h3>
                    <p className="text-lg text-slate-600 dark:text-slate-300 mb-2">
                      {edu.institution}
                    </p>
                    <p className="text-slate-500 dark:text-slate-400">{edu.period}</p>
                  </div>

                  <div className="text-right">
                    <span className="inline-block px-4 py-2 bg-teal-500/20 text-teal-500 rounded-full font-bold text-lg">
                      {edu.grade}
                    </span>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Education;
